(function () {
  'use strict';

  /* ── A3: Sticky Add to Cart bar (mobile only) ───────────── */
  function initStickyATC() {
    var bar = document.querySelector('.woodaha-sticky-atc');
    if (!bar) return;
    var mainBtn = document.querySelector('.product-form__submit.woodaha-atc-btn');
    if (!mainBtn) return;

    var stickyBtn = bar.querySelector('.woodaha-sticky-atc__btn');

    // Mirror click to main product form button
    stickyBtn.addEventListener('click', function () {
      mainBtn.click();
    });

    // Populate title + price from the page
    var h1 = document.querySelector('.product__title h1, h1.product__title');
    var priceEl = document.querySelector(
      '.price--large .price-item--sale, .price--large .price-item--regular, .price--large .price-item'
    );
    var titleEl = bar.querySelector('.woodaha-sticky-atc__title');
    var priceTarget = bar.querySelector('.woodaha-sticky-atc__price');
    if (h1 && titleEl) titleEl.textContent = h1.textContent.trim();
    if (priceEl && priceTarget) priceTarget.textContent = priceEl.textContent.trim();

    // Show/hide via IntersectionObserver
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(mainBtn);
  }

  /* ── A5: "✓ Added to cart" button feedback ──────────────── */
  function initAddedFeedback() {
    var btn = document.querySelector('.product-form__submit.woodaha-atc-btn');
    if (!btn) return;

    var span = btn.querySelector('span:first-child');
    var originalHTML = span ? span.innerHTML : '';
    var wasLoading = false;

    new MutationObserver(function () {
      var isLoading = btn.classList.contains('loading');
      if (wasLoading && !isLoading && !btn.disabled) {
        // Loading just finished and product is still available → success
        btn.classList.add('btn-added');
        if (span) span.innerHTML = '&#10003; Added to cart';

        // Also update sticky bar btn if visible
        var stickyBtn = document.querySelector('.woodaha-sticky-atc__btn');
        if (stickyBtn) {
          stickyBtn.textContent = '✓ Added!';
          stickyBtn.classList.add('is-added');
        }

        setTimeout(function () {
          btn.classList.remove('btn-added');
          if (span) span.innerHTML = originalHTML;
          if (stickyBtn) {
            stickyBtn.textContent = 'Add to Cart';
            stickyBtn.classList.remove('is-added');
          }
        }, 2200);
      }
      wasLoading = isLoading;
    }).observe(btn, { attributes: true, attributeFilter: ['class'] });
  }

  /* ── B3: Gift wrap note textarea toggle ──────────────────── */
  function initGiftWrap() {
    var cb = document.getElementById('woodaha-gift-wrap');
    var noteDiv = document.getElementById('woodaha-gift-note');
    if (!cb || !noteDiv) return;
    cb.addEventListener('change', function () {
      noteDiv.classList.toggle('is-open', this.checked);
    });
  }

  /* ── GEO: Country-specific personalization ──────────────── */
  var GEO_DATA = {
    US: {
      bar: '⚽ Shop <a href="/collections/fifa-world-cup-2026-jigsaw-puzzles" class="woodaha-geo-bar__link">USA host city puzzles</a> — Free shipping $30+',
      hero: { label: '🇺🇸 USA Host', text: 'Your city is in the 2026 World Cup', sub: 'Shop officially licensed USA city poster puzzles', url: '/collections/fifa-world-cup-2026-jigsaw-puzzles', btn: 'Shop USA Puzzles' },
      products: { title: '🇺🇸 Popular with USA fans', handles: ['world-cup-2026-nyc-nj-poster-fifa-jigsaw-puzzle','world-cup-2026-los-angeles-poster-fifa-jigsaw-puzzle','world-cup-2026-miami-poster-fifa-jigsaw-puzzle','world-cup-2026-clutch-mascot-fifa-wooden-art-night-light'] }
    },
    CA: {
      bar: '🍁 Canada hosts the World Cup — <a href="/collections/fifa-world-cup-2026-jigsaw-puzzles" class="woodaha-geo-bar__link">shop officially licensed puzzles</a>',
      hero: { label: '🇨🇦 Canada Host', text: 'Canada at the World Cup 2026', sub: 'Shop officially licensed Canadian collection', url: '/collections/fifa-world-cup-2026-jigsaw-puzzles', btn: 'Shop Canada Collection' },
      products: { title: '🇨🇦 Popular with Canada fans', handles: ['world-cup-2026-toronto-poster-fifa-jigsaw-puzzle','world-cup-2026-canada-ball-fifa-jigsaw-puzzle','world-cup-2026-maple-the-moose-fifa-wooden-art-night-light','world-cup-2026-host-countries-poster-fifa-jigsaw-puzzle'] }
    },
    MX: {
      bar: '🇲🇽 México anfitrión 2026 — <a href="/collections/fifa-world-cup-2026-jigsaw-puzzles" class="woodaha-geo-bar__link">compra tu puzzle oficial</a>',
      hero: { label: '🇲🇽 México Anfitrión', text: 'México anfitrión del Mundial 2026', sub: 'Compra puzzles y lámparas oficialmente licenciados', url: '/collections/fifa-world-cup-2026-jigsaw-puzzles', btn: 'Comprar ahora' },
      products: { title: '🇲🇽 Popular with Mexico fans', handles: ['world-cup-2026-mexico-ball-fifa-jigsaw-puzzle','world-cup-2026-wow-zayu-fifa-wooden-art-night-light','world-cup-2026-mexico-logo-fifa-wooden-art-night-light','world-cup-2026-mexico-ball-fifa-wooden-art-night-light'] }
    },
    GB: {
      bar: '🦁 England at the World Cup 2026 — <a href="/collections/fifa-world-cup-2026-jigsaw-puzzles" class="woodaha-geo-bar__link">shop the officially licensed England puzzle</a>',
      hero: { label: '🏴󠁧󠁢󠁥󠁮󠁧󠁿 Three Lions', text: 'England at the FIFA World Cup 2026', sub: 'Officially licensed England ball wooden puzzle — collectible & unique', url: '/collections/fifa-world-cup-2026-jigsaw-puzzles', btn: 'Shop England Collection' },
      products: { title: '🦁 Popular with England fans', handles: ['fifa-world-cup-2026-fifa-england-ball-wooden-jigsaw-puzzle-200-pieces-5mm-thick','world-cup-2026-golden-trophy-fifa-jigsaw-puzzle','world-cup-2026-host-cities-mosaic-fifa-jigsaw-puzzle','world-cup-2026-official-trophy-fifa-wooden-art-night-light'] }
    },
    FR: {
      bar: '🇫🇷 France at the World Cup 2026 — <a href="/collections/fifa-world-cup-2026-jigsaw-puzzles" class="woodaha-geo-bar__link">shop the officially licensed France puzzle</a>',
      hero: { label: '🇫🇷 Les Bleus 2026', text: 'France at the FIFA World Cup 2026', sub: 'Officially licensed France ball wooden puzzle — limited edition', url: '/collections/fifa-world-cup-2026-jigsaw-puzzles', btn: 'Shop France Collection' },
      products: { title: '🇫🇷 Popular with France fans', handles: ['fifa-world-cup-2026-france-ball-wooden-jigsaw-puzzle-200-pieces-5mm-thick','world-cup-2026-golden-trophy-fifa-jigsaw-puzzle','world-cup-2026-host-cities-mosaic-fifa-jigsaw-puzzle','world-cup-2026-official-trophy-fifa-wooden-art-night-light'] }
    },
    EU: {
      bar: '⚽ FIFA World Cup 2026 — <a href="/collections/fifa-world-cup-2026-jigsaw-puzzles" class="woodaha-geo-bar__link">shop officially licensed puzzles & lamps</a>',
      hero: { label: '🌍 World Cup 2026', text: 'The FIFA World Cup heads to North America', sub: 'Officially licensed wooden puzzles and 3D LED lamps', url: '/collections/fifa-world-cup-2026-jigsaw-puzzles', btn: 'Shop World Cup Collection' },
      products: { title: '⚽ Fan favourites this World Cup', handles: ['world-cup-2026-golden-trophy-fifa-jigsaw-puzzle','world-cup-2026-we-are-26-ball-fifa-jigsaw-puzzle','world-cup-2026-host-cities-mosaic-fifa-jigsaw-puzzle','world-cup-2026-official-trophy-fifa-wooden-art-night-light'] }
    },
    AU: {
      bar: '🦘 Socceroos at the World Cup 2026 — <a href="/collections/fifa-world-cup-2026-jigsaw-puzzles" class="woodaha-geo-bar__link">shop the officially licensed Australia puzzle</a>',
      hero: { label: '🇦🇺 Socceroos 2026', text: 'Australia at the FIFA World Cup 2026', sub: 'Officially licensed Socceroos trophy poster wooden puzzle', url: '/collections/fifa-world-cup-2026-jigsaw-puzzles', btn: 'Shop Australia Collection' },
      products: { title: '🦘 Popular with Australia fans', handles: ['world-cup-2026-australia-poster-fifa-jigsaw-puzzle','world-cup-2026-golden-trophy-fifa-jigsaw-puzzle','world-cup-2026-host-countries-poster-fifa-jigsaw-puzzle','world-cup-2026-official-trophy-fifa-wooden-art-night-light'] }
    },
    JP: {
      bar: '🇯🇵 Japan at the World Cup 2026 — <a href="/collections/fifa-world-cup-2026-jigsaw-puzzles" class="woodaha-geo-bar__link">shop officially licensed FIFA puzzles</a>',
      hero: { label: '🇯🇵 Blue Samurai 2026', text: 'Japan at the FIFA World Cup 2026', sub: 'Officially licensed FIFA wooden puzzles and 3D LED lamps', url: '/collections/fifa-world-cup-2026-jigsaw-puzzles', btn: 'Shop World Cup Collection' },
      products: { title: '🇯🇵 Popular with Japan fans', handles: ['world-cup-2026-golden-trophy-fifa-jigsaw-puzzle','world-cup-2026-trio-of-mascots-fifa-jigsaw-puzzle','world-cup-2026-host-countries-poster-fifa-jigsaw-puzzle','world-cup-2026-official-trophy-fifa-wooden-art-night-light'] }
    },
    KR: {
      bar: '🇰🇷 Korea at the World Cup 2026 — <a href="/collections/fifa-world-cup-2026-jigsaw-puzzles" class="woodaha-geo-bar__link">shop officially licensed FIFA puzzles</a>',
      hero: { label: '🇰🇷 Taeguk Warriors 2026', text: 'Korea at the FIFA World Cup 2026', sub: 'Officially licensed FIFA wooden puzzles and 3D LED lamps', url: '/collections/fifa-world-cup-2026-jigsaw-puzzles', btn: 'Shop World Cup Collection' },
      products: { title: '🇰🇷 Popular with Korea fans', handles: ['world-cup-2026-golden-trophy-fifa-jigsaw-puzzle','world-cup-2026-trio-of-mascots-fifa-jigsaw-puzzle','world-cup-2026-host-countries-poster-fifa-jigsaw-puzzle','world-cup-2026-official-trophy-fifa-wooden-art-night-light'] }
    },
    APAC: {
      bar: '⚽ FIFA World Cup 2026 — <a href="/collections/fifa-world-cup-2026-jigsaw-puzzles" class="woodaha-geo-bar__link">shop officially licensed puzzles & lamps</a>',
      hero: { label: '⚽ World Cup 2026', text: 'The FIFA World Cup 2026 is here', sub: 'Officially licensed FIFA wooden puzzles and 3D LED lamps', url: '/collections/fifa-world-cup-2026-jigsaw-puzzles', btn: 'Shop World Cup Collection' },
      products: { title: '⚽ Fan favourites this World Cup', handles: ['world-cup-2026-golden-trophy-fifa-jigsaw-puzzle','world-cup-2026-we-are-26-ball-fifa-jigsaw-puzzle','world-cup-2026-host-cities-mosaic-fifa-jigsaw-puzzle','world-cup-2026-official-trophy-fifa-wooden-art-night-light'] }
    }
  };

  var COUNTRY_TO_GEO = {
    US:'US', CA:'CA', MX:'MX',
    GB:'GB',
    FR:'FR',
    DE:'EU', AT:'EU', BE:'EU', NL:'EU', ES:'EU', IT:'EU',
    SE:'EU', NO:'EU', PL:'EU', PT:'EU', IE:'EU', DK:'EU',
    FI:'EU', CH:'EU', CZ:'EU', BG:'EU', HR:'EU', HU:'EU', LU:'EU',
    AU:'AU',
    NZ:'APAC', HK:'APAC', SG:'APAC',
    JP:'JP', KR:'KR'
  };

  function initGeoBar(country) {
    var data = GEO_DATA[country];
    if (!data) return;
    var bar = document.getElementById('woodaha-geo-bar');
    if (!bar) return;
    bar.innerHTML = '<div class="page-width"><p class="woodaha-geo-bar__text">' + data.bar + '</p></div>';
    bar.style.display = '';
  }

  function initGeoHero(country) {
    var data = GEO_DATA[country];
    if (!data) return;
    var h = data.hero;
    var firstSection = document.querySelector('.shopify-section');
    if (!firstSection) return;
    var el = document.createElement('div');
    el.className = 'woodaha-geo-hero';
    el.innerHTML = '<div class="page-width woodaha-geo-hero__inner"><span class="woodaha-geo-hero__label">' + h.label + '</span><p class="woodaha-geo-hero__text">' + h.text + '</p><p class="woodaha-geo-hero__sub">' + h.sub + '</p><a href="' + h.url + '" class="woodaha-geo-hero__btn">' + h.btn + ' →</a></div>';
    firstSection.insertAdjacentElement('afterend', el);
  }

  function initGeoProducts(country) {
    var data = GEO_DATA[country];
    if (!data) return;
    var container = document.querySelector('.product__info-container, .product__info-wrapper');
    if (!container) return;
    var handles = data.products.handles;
    var title = data.products.title;
    Promise.all(handles.map(function(h) {
      return fetch('/products/' + h + '.js').then(function(r) { return r.ok ? r.json() : null; }).catch(function() { return null; });
    })).then(function(products) {
      var valid = products.filter(Boolean);
      if (valid.length === 0) return;
      var section = document.createElement('div');
      section.className = 'woodaha-geo-products';
      section.innerHTML = '<h3 class="woodaha-geo-products__title">' + title + '</h3><div class="woodaha-geo-products__grid">' +
        valid.map(function(p) {
          var img = p.featured_image ? p.featured_image + '&width=300' : '';
          return '<a href="/products/' + p.handle + '" class="woodaha-geo-product-card">' + (img ? '<img src="' + img + '" alt="' + p.title + '" loading="lazy" width="150" height="150">' : '') + '<p class="woodaha-geo-product-card__title">' + p.title + '</p></a>';
        }).join('') + '</div>';
      container.insertAdjacentElement('afterend', section);
    });
  }

  function applyGeo(country) {
    if (!country) return;
    var geoKey = COUNTRY_TO_GEO[country] || '';
    if (!geoKey) return;
    initGeoBar(geoKey);
    var bc = document.body.className;
    if (bc.indexOf('template-index') !== -1) initGeoHero(geoKey);
    if (bc.indexOf('template-product') !== -1) initGeoProducts(geoKey);
  }

  function initGeoContent() {
    var cached = sessionStorage.getItem('_wGeo');
    if (cached !== null) { applyGeo(cached); return; }
    fetch('https://ipwho.is/')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        var c = (d && d.country_code) || '';
        sessionStorage.setItem('_wGeo', c);
        applyGeo(c);
      })
      .catch(function() { sessionStorage.setItem('_wGeo', ''); });
  }

  function init() {
    initStickyATC();
    initAddedFeedback();
    initGiftWrap();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Defer geo IP lookup until after page load to avoid blocking LCP
  window.addEventListener('load', function() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(initGeoContent);
    } else {
      setTimeout(initGeoContent, 1000);
    }
  });
})();
